export default {
  intro: {
    default: 'Gib die Angaben der Person ein, die den Vertrag unterschreibt.',
    gbr: 'Gib die Angaben des Gesellschafters ein, der den Vertrag unterschreibt.',
    gmbh: 'Gib die Angaben des Inhabers oder Geschäftsführers ein, der den Vertrag unterschreibt.',
  },
  sections: {
    home_address: 'Privatadresse',
    home_address_help: 'Wo diese Person wohnt, nicht die Adresse des Restaurants.',
  },
  form: {
    owner_first_name: {
      label: 'Vorname',
      placeholder: 'Vornamen eingeben',
    },
    owner_last_name: {
      label: 'Nachname',
      placeholder: 'Nachnamen eingeben',
    },
    owner_dob: {
      label: 'Geburtsdatum',
      placeholder: 'Datum',
    },
    owner_phone_number: {
      label: 'Telefonnummer',
    },
    owner_email: {
      label: 'E-Mail',
      placeholder: 'E-Mail eingeben',
      help: 'Diese E-Mail-Adresse kann eine andere sein als die, mit der du dich anmeldest.',
    },
    owner_id_number: {
      label: 'ID-Nummer (z. B. Sozialversicherungsnummer in den USA)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Zurück',
    next: 'Weiter',
  },
};
